/* global require */

require('what-input/dist/what-input.js');
require('../img/sprite-svg/sprite-svg.js');
require('../js/global-scripts.js');
require('../components/card-project/card-project.js');
require('../components/checkbox/checkbox.js');
require('../components/contacts-grid/contacts-grid.js');
require('../components/form/form.js');
require('../components/hybrid-map/hybrid-map.js');
require('../components/modal/modal.js');
require('../components/select/select.js');
require('../blocks/about/about.js');
require('../blocks/about-history/about-history.js');
require('../blocks/about-mission/about-mission.js');
require('../blocks/about-team/about-team.js');
require('../blocks/about-why/about-why.js');
require('../blocks/agro/agro.js');
require('../blocks/assets-catalog/assets-catalog.js');
require('../blocks/contacts/contacts.js');
require('../blocks/footer/footer.js');
require('../blocks/header/header.js');
require('../blocks/hero-land/hero-land.js');
require('../blocks/land-features/land-features.js');
require('../blocks/m-about/m-about.js');
require('../blocks/m-consultation/m-consultation.js');
require('../blocks/m-hero/m-hero.js');
require('../blocks/m-projects/m-projects.js');
require('../blocks/m-why/m-why.js');
require('../blocks/modal-land-area/modal-land-area.js');
require('../blocks/podosinki/podosinki.js');
require('../blocks/press/press.js');
require('../blocks/projects/projects.js');
require('../blocks/villages/villages.js');
